import React, { useState, useCallback } from "react";
import { Field, Form } from "react-final-form";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../components/DetailedErrorAlert";
import { TextInput } from "../../../components/inputs/final_form/TextInput";
import { LoadingButton } from "../../../components/LoadingButton";
import { api, extractErrorMessage } from "../../../util/api";
import { required } from "../../../util/validators";
import { snakifyKeys } from "../../../util/helpers";
import { AdminOptionableInput } from "../../components/inputs/AdministrateSelectInput";

export const AddPortalCodeGroupModal = ({ portal, onAdd, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen((x) => !x);

  const handleCreate = useCallback(
    async (values) => {
      setError(null);
      try {
        const { data } = await api.post("/admin/benefit_management_portal_code_groups", {
          benefit_management_portal_code_group: snakifyKeys(values),
        });

        onAdd?.(data);
        setOpen(false);
      } catch (err) {
        setError(extractErrorMessage(err));
      }
    },
    [onAdd]
  );

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Add Code Group
      </Button>

      <Modal isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Add Code Group</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleCreate} initialValues={{ benefitManagementPortalId: portal.id }}>
            {({ handleSubmit, submitting }) => (
              <>
                <Field component={TextInput} type="hidden" name="benefitManagementPortalId" />
                <Field
                  component={AdminOptionableInput}
                  resource="code_groups"
                  label="Code Group"
                  name="codeGroupId"
                  searchParam="name"
                  required
                  validate={required}
                />

                <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting}>
                  Submit
                </LoadingButton>
              </>
            )}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
